import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
var ReportLevelExplainComponent = (function () {
    function ReportLevelExplainComponent(commonService, apiService, route) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.assetsRoute = "../../assets";
    }
    ReportLevelExplainComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var _this = this;
        if (this.reportKAData) {
            _this.report = this.reportKAData;
            _this.reportLV = this.reportKAData.level;
        }
        // $.ajax({
        //   url: "/op/insideapi/getlevel",
        //   type: "post",
        //   dataType:'json',
        //   contentType:'application/json;charset=utf-8',
        //   data:JSON.stringify(_this.reportKAData) ,
        //   async: false,
        //   success:function(result){
        //     if(result && result != ""){
        //       _this.report = result;
        //       _this.reportLV = result.level;
        //       _this.isShowReportLv = true;
        //     }else{
        //     	_this.exitReportLevel();
        //     }
        //   },
        //   error:function(er){
        //   	_this.exitReportLevel();
        //   }
        // });
    };
    ReportLevelExplainComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.reportKAData) {
            // step1: 背景虚化
            setTimeout(function () {
                $('#reportLevel').addClass('opacity100').show();
                $('#wrap').addClass('bgBlur');
            }, 1000);
            // step2：准备icon出现-->环形进度条出现
            setTimeout(function () {
                $('[class*="chatItem-dark-"]').addClass('opacity100');
                // $('.ready-default').addClass('opacity100');
            }, 1500);
            // step3： 环形进度条发光-->抖动动画准备
            setTimeout(function () {
                var num = _this.reportLV;
                for (var i = 0, len = num; i < len; i += 1) {
                    $('[class*="chatItem-light-"]').eq(i).addClass('opacity100');
                }
                $('.ready-level-icon').addClass('shake-rotate');
            }, 1500);
        }
    };
    ReportLevelExplainComponent.prototype.exitReportLevel = function () {
        $('#reportLevel').hide();
        $('#wrap').removeClass('bgBlur');
    };
    return ReportLevelExplainComponent;
}());
export { ReportLevelExplainComponent };



// WEBPACK FOOTER //
// ./src/app/report-level-explain/report-level-explain.component.ts.pre-build-optimizer.js